import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2BuddyEvent } from "../../../event/Poker2BuddyEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2StandardOkDialog } from "../../../view/dialogs/Poker2StandardOkDialog";
import { Poker2Command } from "../Poker2Command";

export class CIFCommand extends Poker2Command {
    protected get cmdId(): string {
        return "cif";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            this.controller.dispatchEvent(new Poker2BuddyEvent("inviteFriendComplete"));
            this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(
                Poker2Model.languageData.getTextById("alert_invitefriend_title"),
                Poker2Model.languageData.getTextById("alert_invitefriend_copy")));
        }
        else {
            this.controller.dispatchEvent(new Poker2BuddyEvent("inviteFriendFaild"));
            if (super.executeCommand(error, params))
                this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(
                    Poker2Model.languageData.getTextById("alert_invitefriend_title"),
                    Poker2Model.languageData.getTextById("errorcode_" + error)));
        }
        return (error == 0);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
